import { render, staticRenderFns } from "./payment-helper-wage-plan.vue?vue&type=template&id=e248420c&scoped=true"
import script from "./payment-helper-wage-plan.vue?vue&type=script&lang=js"
export * from "./payment-helper-wage-plan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e248420c",
  null
  
)

export default component.exports